export const CHAIN = {
  name: "Blokista Chain",
  symbol: "BCC",
  chainId: 90909,
  chainIdHex: "0x1631d",
  rpcUrl: `${process.env.REACT_APP_BACKEND_URL}/api/rpc`,
  decimals: 18,
};

export const shorten = (s, a = 6, b = 4) => {
  if (!s) return "";
  if (s.length <= a + b + 2) return s;
  return `${s.slice(0, a)}…${s.slice(-b)}`;
};

export const timeAgo = (ts) => {
  if (!ts) return "-";
  const secs = Math.max(0, Math.floor(Date.now() / 1000 - ts));
  if (secs < 60) return `${secs}s ago`;
  const m = Math.floor(secs / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  return `${Math.floor(h / 24)}d ago`;
};

export const fmtNum = (n) => {
  if (n === null || n === undefined) return "-";
  return Number(n).toLocaleString("en-US");
};

export const fmtEth = (v, dp = 4) => {
  if (v === null || v === undefined) return "0";
  const n = Number(v);
  if (n === 0) return "0";
  if (n < 0.0001) return "<0.0001";
  return n.toLocaleString("en-US", { maximumFractionDigits: dp });
};

export const copy = (text) => navigator.clipboard?.writeText(text);

// BCC-20 / common selectors -> method label
const SELECTORS = {
  "0xa9059cbb": "Transfer",
  "0x23b872dd": "TransferFrom",
  "0x095ea7b3": "Approve",
  "0x40c10f19": "Mint",
  "0x": "Transfer",
};
export const methodOf = (input) => {
  if (!input || input === "0x") return "Transfer";
  const sel = input.slice(0, 10);
  return SELECTORS[sel] || "Call";
};

export const methodClass = (m) => {
  switch (m) {
    case "Transfer": return "pill-green";
    case "Approve": return "pill-amber";
    case "Mint": return "pill-amber";
    case "Call": case "TransferFrom": return "pill-muted";
    default: return "pill-muted";
  }
};

// deterministic color from address for avatar
export const addrColor = (addr) => {
  if (!addr) return "#7E8B99";
  const palette = ["#F5A623", "#4C9DF0", "#34D399", "#B98BF0", "#F2555A", "#FFB944", "#2DD4BF"];
  let h = 0;
  for (let i = 2; i < addr.length; i++) h = (h * 31 + addr.charCodeAt(i)) & 0xffffffff;
  return palette[Math.abs(h) % palette.length];
};
